/** @flow */
import React from 'react';
import Radio from 'common/domain/radio';
import PrintingService from 'common/services/PrintingService';
import PrintingPage from 'common/components/PrintingPage';

import type { ReachState } from './domain/State';
import { parseReachState } from './domain/State';
import ReachPrinting from './printing/ReachPrinting';

type State = {
  reach: ReachState;
  loading: boolean;
  radio: Radio;
}

class ReachPrintingPage extends React.Component<any, State> {
  constructor(props: any) {
    super(props);

    const data = PrintingService.getData('REACH_PRINTING_DATA');
    if (!data) {
      return;
    }

    this.state = {
      loading: false,
      reach: parseReachState(data.reach),
      radio: data.radio,
    };
    setTimeout(() => window.print(), 1000);
  }

  render() {
    if (!this.state) {
      return null;
    }

    const { loading, reach, radio } = this.state;
    return (
      <PrintingPage loading={loading}>
        {reach && radio &&
          <ReachPrinting reach={reach} radio={radio} />
        }
      </PrintingPage>
    );
  }
}

export default ReachPrintingPage;



// WEBPACK FOOTER //
// ./src/statsradio/modules/metrics/ReachPrintingPage.js